/**
 * Resolução de variável para os previews do editor de fluxo.
 *
 * Espelha o `FluxoRenderService` do backend: sistema/contato primeiro (tem
 * precedência), depois os parâmetros do fluxo pelo `padrao` declarado, e por
 * último nada de placeholder cru — porque é assim que a mensagem sai de fato.
 *
 * Antes existiam 3 cópias de um `replace` de `{{nome}}`/`{{telefone}}`, o que
 * fazia o preview mentir sobre o que o contato receberia.
 */

const EXEMPLOS_SISTEMA = {
  nome: 'João Silva',
  primeiro_nome: 'João',
  telefone: '(11) 98765-4321',
  data: new Date().toLocaleDateString('pt-BR'),
  hora: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
  dia_semana: new Date().toLocaleDateString('pt-BR', { weekday: 'long' }),
  usuario_nome: 'Maria Santos',
  cliente_nome: 'Sua Empresa',
};
EXEMPLOS_SISTEMA.data_hora = `${EXEMPLOS_SISTEMA.data} às ${EXEMPLOS_SISTEMA.hora}`;

export const CHAVES_SISTEMA = Object.keys(EXEMPLOS_SISTEMA);

/**
 * @param texto      mensagem da etapa
 * @param variaveis  declaração do fluxo ([{chave, padrao}])
 * @param valores    valores de um canal, quando houver
 */
export function resolverPreview(texto, variaveis = [], valores = {}) {
  if (!texto) return texto;

  const padroes = {};
  for (const v of variaveis || []) {
    if (v?.chave) padroes[String(v.chave).toLowerCase()] = v.padrao ?? '';
  }

  return String(texto).replace(/\{\{(\w+)\}\}/g, (_m, bruta) => {
    const chave = bruta.toLowerCase();
    if (EXEMPLOS_SISTEMA[chave] !== undefined) return EXEMPLOS_SISTEMA[chave];
    const doCanal = valores?.[chave];
    if (doCanal) return doCanal;
    if (padroes[chave]) return padroes[chave];
    // Sem valor, o backend manda vazio. Marcar no preview é o único jeito de o
    // operador perceber antes de ativar o fluxo.
    return `⟨${chave}⟩`;
  });
}

/** Chaves usadas no texto que não resolvem — nem sistema, nem declaradas. */
export function pendentesNoPreview(textos = [], variaveis = []) {
  const declaradas = (variaveis || []).map((v) => String(v?.chave || '').toLowerCase());
  const faltando = new Set();
  for (const t of textos.filter(Boolean)) {
    for (const [, bruta] of String(t).matchAll(/\{\{(\w+)\}\}/g)) {
      const chave = bruta.toLowerCase();
      if (CHAVES_SISTEMA.includes(chave)) continue;
      const decl = (variaveis || []).find((v) => String(v?.chave).toLowerCase() === chave);
      if (!declaradas.includes(chave) || !decl?.padrao) faltando.add(chave);
    }
  }
  return [...faltando];
}
